<template>
  <div class="fakeSiteLayoutContainer">
    <fake-site-header></fake-site-header>
    <fake-site-navigation></fake-site-navigation>
    <fake-site-search-menu></fake-site-search-menu>
    <div class="wrapper appWrapper">
      <keep-alive :include="keepAlive">
        <c-loading-spinner v-if="loading"></c-loading-spinner>
        <router-view v-else class="viewContainer" id="routerViewport"></router-view>
      </keep-alive>
    </div>
    <fake-site-social-footer></fake-site-social-footer>
    <fake-site-footer></fake-site-footer>
  </div>
</template>

<script>
import FakeSiteFooter from './FakeSiteFooter'
import FakeSiteHeader from './FakeSiteHeader'
import FakeSiteNavigation from './FakeSiteNavigation'
import FakeSiteSearchMenu from './FakeSiteSearchMenu'
import FakeSiteSocialFooter from './FakeSiteSocialFooter'

export default {
  components: {
    'fake-site-footer': FakeSiteFooter,
    'fake-site-header': FakeSiteHeader,
    'fake-site-navigation': FakeSiteNavigation,
    'fake-site-search-menu': FakeSiteSearchMenu,
    'fake-site-social-footer': FakeSiteSocialFooter,
  },
  props: { keepAlive: { default: () => [], type: Array }, loading: { type: Boolean } },
}
</script>
